// AddPermission — modal-embedded form for creating a Permission row.
// Refactored 2026-05-05 (Phase 3.1, Class P) onto ModalFormHeader.

import React, { useState } from 'react';
import CTextField from '../CTextField/CTextField';
import { Button, Stack, Box, Typography } from '@mui/material';
import { LockOpenOutlined } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import CSwitch from '../CSwitch/CSwitch';
import { createPermission } from '../../feature/permissionsSlice';
import { toast } from 'react-toastify';
import { ModalFormHeader } from '../PaperForm';

const AddPermission = (props) => {
  const dispatch = useDispatch();
  const [isActive, setActive] = useState(false);
  const [data, setData] = useState({ name: '' });

  const handleChange = (event) => {
    setData((prv) => ({ ...prv, [event.target.name]: event.target.value }));
  };

  const handleSubmit = () => {
    let finalData = { ...data, isActive };
    dispatch(createPermission(finalData)).then((res) => {
      if (res.type === 'createPermission/permissions/fulfilled') {
        toast('Permission created successfully!');
        props.setOpen(false);
      }
    });
  };

  return (
    <Box>
      <ModalFormHeader
        overline="SFM · Permission"
        title="Add Permission"
        icon={LockOpenOutlined}
        rightSlot={
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <Typography variant="caption" sx={{ color: 'text.secondary' }}>Active</Typography>
            <CSwitch label="Active" active={isActive} setSwitch={() => setActive(!isActive)} />
          </Stack>
        }
      />
      <Stack spacing={2}>
        <CTextField onChange={handleChange} name="name" label="Permission name" required />
        <Button
          disabled={props.isLoading}
          onClick={handleSubmit}
          variant="contained"
          sx={{
            width: '100%',
            mt: 1,
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
            letterSpacing: '0.01em',
          }}
        >
          {props.isLoading ? 'Loading…' : 'Create Permission'}
        </Button>
      </Stack>
    </Box>
  );
};

export default AddPermission;
